import React, {Component} from 'react';
import {Route} from 'react-router-dom'
import {withRouter} from "react-router";
import {connect} from 'react-redux';
import {Transition} from 'semantic-ui-react'
import {Player, ControlBar} from 'video-react';
import Div100vh from 'react-div-100vh'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import {setMenuVisible, playCutSceneVideo, pageChange} from './actions'
import {loadResourcesLatest, getBackground, getCutSceneVideo} from './utils/homeUtils'
import MainMenu from './components/MainMenu'
import Home from './pages/Home'
import About from './pages/About'
import Latest from './pages/Latest'
import Producer from './pages/Producer'
import Production from './pages/Production'
import ProductionList from './pages/ProductionList'
import CoProduction from './pages/CoProduction'
import CoProductionInfo from './pages/CoProductionInfo'
import Department from './pages/Department'
import DepartmentInfo from './pages/DepartmentInfo'
import Contact from './pages/Contact'

import 'semantic-ui-css/semantic.min.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-circular-progressbar/dist/styles.css';
import './App.scss';


class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDesktop: true,
            loadingVisible: true,
            loadingPercentage: 0,
            mainMenuVisible: false,
            mainContentVisible: true,
            isCutScenePlayed: false,
            isResourceLoaded: false,

            cutsceneVideoVisible: false,
            cutsceneVideoUrl: "",

            isInit: false,
            paramChangeOnResize: true
        }

        this.handleMenuHideComplete = this.handleMenuHideComplete.bind(this);
        this.onLoadFilesProgress = this.onLoadFilesProgress.bind(this);
        this.onLoadFilesComplete = this.onLoadFilesComplete.bind(this);

        this.homePage = React.createRef();
        this.player = React.createRef();

        if (!localStorage.getItem("language")) {
            localStorage.setItem("language", "TW");
        }
    }

    componentDidMount() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw >= 768) {
            this.setState({ isDesktop: true });
            loadResourcesLatest(this.onLoadFilesProgress, this.onLoadFilesComplete);
        } else {
            this.setState({ isDesktop: false, loadingVisible: false });
        }

        const backgroundImagePath = getBackground("/", (vw >= 768));
        this.backgroundLayer.style.backgroundImage = "url(" + backgroundImagePath + ")";

        window.addEventListener('resize', () => {
            this.setState({ paramChangeOnResize: !this.state.paramChangeOnResize })
        });
    }

    onLoadFilesProgress(event) {
        this.setState({ loadingPercentage: Math.floor(event.loaded * 100) });
    }

    onLoadFilesComplete(event) {
        this.setState({ loadingVisible: false, isInit: true });
        setTimeout(() => {
            this.props.pageChange({
                prevUrl: "/",
                nextUrl: "/"
            });
        }, 0);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.pageInfo.nextUrl !== "") {
            if (JSON.stringify(prevProps.pageInfo) !== JSON.stringify(this.props.pageInfo)) {
                const vw = Math.max(document.documentElement.clientWidth || 0,
                  window.innerWidth || 0);
                if (vw >= 768) {
                    setTimeout(() => {
                        const videoPath = getCutSceneVideo(this.props.pageInfo.prevUrl,
                          this.props.pageInfo.nextUrl);
                        this.setState({ cutsceneVideoUrl: videoPath });
                    }, 0);

                } else {
                    this.changePageBackground();
                    this.props.history.push(this.props.pageInfo.nextUrl);
                }

            }
        }

        if (prevState.cutsceneVideoUrl !== this.state.cutsceneVideoUrl && this.state.cutsceneVideoUrl !== undefined) {
            setTimeout(() => {
                this.player.load();
            }, 200);
        }

        if (this.state.mainMenuVisible != this.props.isMenuVisible) {
            this.setState({ mainMenuVisible: this.props.isMenuVisible });
        }

        if (this.state.isInit === true) {
            this.player.subscribeToStateChange(this.handleVideoStateChange.bind(this));
        }

        if (prevState.cutsceneVideoVisible === false && this.state.cutsceneVideoVisible) {
            this.changePageBackground();
            setTimeout(() => {
                this.player.play();
            }, 200);
        }
    }

    changePageBackground = () => {
        const backgroundImagePath = getBackground(this.props.pageInfo.nextUrl,
          this.state.isDesktop);
        this.backgroundLayer.style.backgroundImage = "url(" + backgroundImagePath + ")";
    }


    handleVideoStateChange() {
        const { player } = this.player.getState();

        if (this.state.isDesktop && player.readyState === 4 && !player.hasStarted) {
            // this.changePageBackground();
            // this.state.mainMenuVisible = false;
            this.setState({
                cutsceneVideoVisible: true
            });
            setTimeout(() => {
                this.player.play();
            }, 200);
            return;
        }

        if (player.ended) {
            this.setState({ isCutScenePlayed: true, cutsceneVideoVisible: false });
            this.props.history.push(this.props.pageInfo.nextUrl);
        }
    }

    handleMenuHideComplete() {
        if (this.state.isDesktop) {
            // this.player.play();
        }
    }

    render() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        let isDesktop;
        if (vw >= 768) {
            isDesktop = true;
        } else {
            isDesktop = false;
        }
        let scaleWidth;
        scaleWidth = (vw > 1920) ? 1920 : vw;

        let transformPosition = (vw > 1280) ? "top center" : "top left";

        return (
          <>
              <input type="hidden" value={this.state.paramChangeOnResize}/>
              {isDesktop ? (
                <div id="page_container">
                    <div id="content_container" style={{
                        transform: `scale(${scaleWidth / 1280})`,
                        transformOrigin: transformPosition
                    }}>
                        <div className="content_wrapper">
                            <Transition visible={this.state.loadingVisible} animation='fade'
                                        duration={500}>
                                <div className="loading_container">
                                    <div className="loading_circle">
                                        <CircularProgressbar
                                          value={this.state.loadingPercentage}
                                          text={`${this.state.loadingPercentage}%`}
                                          strokeWidth="4"
                                          styles={{
                                              // Customize the root svg element
                                              root: {
                                                  width: "120px",
                                                  height: "120px"
                                              },
                                              // Customize the path, i.e. the "completed progress"
                                              path: {
                                                  // Path color
                                                  stroke: `rgba(201, 202, 202, ${this.state.loadingPercentage})`,
                                                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                  strokeLinecap: 'butt',
                                                  // Customize transition animation
                                                  transition: 'stroke-dashoffset 0.5s ease 0s',
                                                  // Rotate the path
                                                  // transform: 'rotate(0.25turn)',
                                                  transformOrigin: 'center center',
                                              },
                                              // Customize the circle behind the path, i.e. the "total progress"
                                              trail: {
                                                  // Trail color
                                                  stroke: '#FFFFFF',
                                                  opacity: "0.4",
                                                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                  strokeLinecap: 'butt',
                                                  // Rotate the trail
                                                  // transform: 'rotate(0.25turn)',
                                                  transformOrigin: 'center center',
                                              },
                                              // Customize the text
                                              text: {
                                                  display: "none",
                                              },
                                              // Customize background - only used when the `background` prop is true
                                              background: {
                                                  fill: '#3e98c7',
                                              },
                                          }}
                                        />;
                                    </div>
                                </div>
                            </Transition>

                            { this.state.isInit &&  (
                            <Transition visible={this.state.mainMenuVisible} animation='fade'
                                        duration={500}
                                        onHide={this.handleMenuHideComplete}>
                                <div id="main_menu">
                                    <MainMenu className="main_menu_content"/>
                                </div>
                            </Transition>
                            )}

                            <div id="main_content_background" ref={(backgroundLayer) => {
                                this.backgroundLayer = backgroundLayer
                            }}></div>

                            <div id="cutscene_video_wrapper"
                                 className={this.state.cutsceneVideoVisible ? null : 'not_visible'}>
                                <div className="cutscene_video_overlay"></div>
                                <Player className="cutscene_video_player" preload="auto"
                                        muted={true} ref={(player) => {
                                    this.player = player
                                }}>
                                    <ControlBar autoHide={false}/>
                                    <source
                                      src={process.env.PUBLIC_URL + this.state.cutsceneVideoUrl}/>
                                </Player>
                            </div>

                            { this.state.isInit &&  (
                            <Transition visible={this.state.mainContentVisible} animation='fade'
                                        duration={500}>
                                <div id="main_content">
                                    <Route path="/" exact component={Home} ref={(homePage) => {
                                        this.homePage = homePage
                                    }}/>
                                    <Route path="/latest" exact component={Latest}
                                           isDesktop={isDesktop}/>
                                    <Route path="/about" exact component={About}/>
                                    <Route path="/producer" exact component={Producer}/>
                                    <Route path="/production_list" exact
                                           component={ProductionList}/>
                                    <Route path="/production/:productionId" exact
                                           component={Production}/>
                                    <Route path="/co_production" exact component={CoProduction}/>
                                    <Route path="/co_production/:productionId" exact
                                           component={CoProductionInfo}/>
                                    <Route path="/department" exact component={Department}/>
                                    <Route path="/department/:productionId" exact
                                           component={DepartmentInfo}/>
                                    <Route path="/contact" exact component={Contact}/>
                                </div>
                            </Transition>
                            )}

                        </div>
                    </div>
                </div>
              ) : (
                <Div100vh id="page_container">
                    <div id="content_container">
                        <div className="content_wrapper">
                            {/* <Transition visible={this.state.loadingVisible} animation='scale' duration={500}> */}
                            {/* <div className="loading_container">
                                        <div className="loading_percentage center">{this.state.loadingPercentage}%</div>
                                    </div> */}
                            {/* </Transition> */}

                            <Transition visible={this.state.mainMenuVisible} animation='scale'
                                        duration={500}
                                        onHide={this.handleMenuHideComplete}>
                                <div id="main_menu">
                                    <MainMenu className="main_menu_content"/>
                                </div>
                            </Transition>

                            <div id="main_content_background" ref={(backgroundLayer) => {
                                this.backgroundLayer = backgroundLayer
                            }}></div>

                            {/* <Transition visible={this.state.mainContentVisible} animation='scale' duration={500}> */}
                            <div id="main_content">
                                <Route path="/" exact component={Home} ref={(homePage) => {
                                    this.homePage = homePage
                                }}/>
                                <Route path="/latest" exact component={Latest}/>
                                <Route path="/about" exact component={About}/>
                                <Route path="/producer" exact component={Producer}/>
                                <Route path="/production_list" exact component={ProductionList}/>
                                <Route path="/production" exact component={Production}/>
                                <Route path="/production/:productionId" exact
                                       component={Production}/>
                                <Route path="/co_production" exact component={CoProduction}/>
                                <Route path="/co_production/:productionId" exact
                                       component={CoProductionInfo}/>
                                <Route path="/department" exact component={Department}/>
                                <Route path="/department/:productionId" exact
                                       component={DepartmentInfo}/>
                                <Route path="/contact" exact component={Contact}/>
                            </div>
                            {/* </Transition> */}
                        </div>
                    </div>
                </Div100vh>
              )}

          </>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isMenuVisible: state.isMenuVisible,
        pageInfo: state.pageInfo
    };
};

App = withRouter(App);
export default connect(mapStateToProps, {setMenuVisible, pageChange})(App);
